/* eslint-disable react/prop-types */
import React, {createContext, useContext, useState, useEffect, useCallback} from 'react'


import PropTypes from 'prop-types'

const CartContext = createContext({})

export const CartProvider = ({ children }) => {
 // const [cartProducts, setCartProducts] = useState([])
  const [address, setAddress] = useState({})
  const [updateCart, setUpdateCart] = useState()
  // const putProductInCart = async products => {
  //
  //   async function addProductCart (product){
  //     const productCart = {}
  //     productCart.product_uuid = product[0].id
  //     productCart.quantity = 1
  //     productCart.partner_customer_id = "02792775122"
  //
  //     // api.post('/cart',productCart)
  //     // .then(sucess =>{
  //
  //     // })
  //     // .catch(err =>{
  //
  //     // })
  //
  //
  //   }
  //
  //   async function editProductCart (product, quantity){
  //     const productCart = {}
  //     productCart.product_uuid = product[0].id
  //     productCart.quantity = quantity
  //     productCart.partner_customer_id = "02792775122"
  //
  //     // api.put('/cart',productCart)
  //     // .then(sucess =>{
  //
  //     // })
  //     // .catch(err =>{
  //
  //     // })
  //   }
  //
  //   const cartIndex = cartProducts.findIndex(prd => prd.id === products[0].id)
  //   let newCartProducts = []
  //   if (cartIndex >= 0) {
  //     editProductCart(products,cartProducts[cartIndex].quantity + 1)
  //     newCartProducts = cartProducts
  //     newCartProducts[cartIndex].quantity = newCartProducts[cartIndex].quantity + 1
  //     setCartProducts(newCartProducts)
  //   } else {
  //     addProductCart(products)
  //     products[0].quantity = 1
  //     cartProducts.push(products[0])
  //     newCartProducts = cartProducts
  //     setCartProducts(cartProducts)
  //   }
  //   await localStorage.setItem('trigg:cart', JSON.stringify(newCartProducts))
  // }

  // /* putProductInCart é uma função que adiciona um produto no carrinho de compras. */
  //
  // /*  loadUserdata é uma função que carrega os dados do usuário do localStorage. */
  //
  // const deleteProduct = async productId => {
  //   const newCart = cartProducts.filter(products => products.id !== productId)
  //   setCartProducts(newCart)
  //   await localStorage.setItem('trigg:cartInfo', JSON.stringify(newCart))
  // }
  //
  // const increaseProducts = async productId => {
  //   const newCart = cartProducts.map(products => {
  //     return products.id === productId
  //       ? { ...products, quantity: products.quantity + 1 }
  //       : products
  //   })
  //   setCartProducts(newCart)
  //   await localStorage.setItem('trigg:cartInfo', JSON.stringify(newCart))
  // }
  //
  // const decreaseProducts = async productId => {
  //   const cartIndex = cartProducts.findIndex(pd => pd.id === productId)
  //
  //   if (cartProducts[cartIndex].quantity > 1) {
  //     const newCart = cartProducts.map(products => {
  //       return products.id === productId
  //         ? { ...products, quantity: products.quantity - 1 }
  //         : products
  //     })
  //     setCartProducts(newCart)
  //     await localStorage.setItem('trigg:cartInfo', JSON.stringify(newCart))
  //   } else {
  //     /*  deleteProduct(productId) */
  //   }
  // }

  const changeAddress = useCallback((address) => {

  //  console.log('newaddress', address)

    setAddress(address)
  }, []);

  const getAddress = () => {
    return address
  }

  // useEffect(() => {
  //   const loadUserData = async () => {
  //     const clientCartData = await localStorage.getItem('trigg:cartData')
  //     /* LocalStorage serve para armazenar dados por exemplo de login ou guardar item no carrinho de compras. */
  //     if (clientCartData) {
  //       setCartProducts(JSON.parse(clientCartData))
  //     }
  //   }
  //   loadUserData()
  // }, [])

  // return (
  //   <CartContext.Provider value={{ putProductInCart, cartProducts, increaseProducts, decreaseProducts, deleteProduct, changeAddress, getAddress }}> {/*  value é o valor que será passado para o contexto. */}
  //     {children}
  //   </CartContext.Provider>
  // )

  return (
      <CartContext.Provider value={{changeAddress, getAddress, updateCart, setUpdateCart }}> {/*  value é o valor que será passado para o contexto. */}
        {children}
      </CartContext.Provider>
  )

}

export const useCart = () => {
  const context = useContext(CartContext) /* useContext() é uma função que retorna o contexto atual do componente. */
  if (!context) {
    throw new Error('useCart must be used within a CartProvider')
  }
  return context
}

CartProvider.propTypes = {
  children: PropTypes.node,
  address: PropTypes.object,
}
